export default {
  stepsCompleted: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'sticky',
    zIndex: 5,
    top: 0,
    padding: '1.5rem 1.5rem',
    pt: '1.55rem',
    borderRadius: '0 0 16px 16px',
    mb: '1rem'
  },
  formNameWrapper: {
    margin: '1rem auto',
    mt: '2.5rem',
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '4px',
    boxShadow: '2px 2px 4px 0px rgba(165, 165, 165, 0.16)',
    padding: '.4rem'
  },
  paymentCompleteAlert: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& .MuiAlert-message': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'left'
    }
  },
  bottomStickyWrapper: {
    width: '100%',
    p: '1.1rem 0.8rem',
    display: 'flex',
    flexFlow: 'column',
    rowGap: '1.5rem',
    borderTop: '1px solid',
    borderColor: 'border.lighter',
    zIndex: 10,
    backgroundColor: 'bg.white',
    position: 'sticky',
    bottom: 0
  }
};
